export default __webpack_public_path__ + "static/media/gmail-logo.698ef3f9.gif";